

// import React, { useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
// import Header from '../headerFooter/header';
// import HomeFooter from '../homepage/homefooter';
// import './classesandForm.css'; // Unified CSS

// const YogaRegistrationForm = () => {
//   const { state } = useLocation();
//   const navigate = useNavigate();
//   const { productName, amount, description } = state || { productName: "Yoga Class", amount: 1500 };

//   const [formData, setFormData] = useState({
//     name: '', email: '', phone: '', dob: '', gender: '', timeSlot: '', experience: '', goals: ''
//   });
//   const [errors, setErrors] = useState({});

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Basic Validation Logic here (simplified for brevity)
//     if (!formData.name || !formData.email || !formData.phone) {
//         alert("Please fill in all required fields.");
//         return;
//     }
    
//     navigate('/payment', {
//         state: { yogaRegistrationData: formData, productName, amount, quantity: 1 }
//     });
//   };

//   return (
//     <div className="form-page-wrapper">
//       <Header />
      
//       <form onSubmit={handleSubmit} className="satvic-form">
//         <h2>{productName} Registration</h2>
//         <p className="amount-display">Fee: ₹{amount}</p>
        
//         {description && (
//             <div className="batch-info-box">
//                 <p>{description}</p>
//             </div>
//         )}

//         <div className="form-grid">
//             <div className="full-width">
//                 <label>Full Name *</label>
//                 <input type="text" name="name" value={formData.name} onChange={handleInputChange} required />
//             </div>

//             <div>
//                 <label>Email *</label>
//                 <input type="email" name="email" value={formData.email} onChange={handleInputChange} required />
//             </div>

//             <div>
//                 <label>Phone *</label>
//                 <PhoneInput country={'in'} value={formData.phone} onChange={phone => setFormData({...formData, phone})} />
//             </div>

//             <div>
//                 <label>Date of Birth *</label>
//                 <input type="date" name="dob" value={formData.dob} onChange={handleInputChange} max={new Date().toISOString().split("T")[0]} required />
//             </div>

//             <div>
//                 <label>Gender *</label>
//                 <select name="gender" value={formData.gender} onChange={handleInputChange} required>
//                     <option value="">Select</option>
//                     <option value="Male">Male</option>
//                     <option value="Female">Female</option>
//                 </select>
//             </div>

//             <div className="full-width">
//                 <label>Select Time Slot *</label>
//                 <div className="selection-group">
//                     <label><input type="radio" name="timeSlot" value="Morning" onChange={handleInputChange} /> Morning </label>
//                     <label><input type="radio" name="timeSlot" value="Evening" onChange={handleInputChange} /> Evening </label>
//                 </div>
//             </div>

//             <div className="full-width">
//                 <label>Experience Level *</label>
//                 <div className="selection-group">
//                     <label><input type="radio" name="experience" value="Beginner" onChange={handleInputChange} /> Beginner</label>
//                     <label><input type="radio" name="experience" value="Intermediate" onChange={handleInputChange} /> Intermediate</label>
//                     <label><input type="radio" name="experience" value="Advanced" onChange={handleInputChange} /> Advanced</label>
//                 </div>
//             </div>

//             <div className="full-width">
//                 <label>Your Goals</label>
//                 <textarea name="goals" rows="3" value={formData.goals} onChange={handleInputChange} placeholder="What do you hope to achieve?"></textarea>
//             </div>
//         </div>

//         <button type="submit" className="submit-btn">Proceed to Payment</button>
//       </form>

//       <HomeFooter />
//     </div>
//   );
// };

// export default YogaRegistrationForm;


import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Header from '../headerFooter/header';
import HomeFooter from '../homepage/homefooter';
import './classesandForm.css';

const YogaRegistrationForm = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { productName, amount, description } =
    state || { productName: 'Yoga Class', amount: 1500 };

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    dob: '',
    gender: '',
    timeSlot: '',
    experience: '',
    goals: '',
  });

  const [consent, setConsent] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.phone) {
      alert('Please fill in all required fields.');
      return;
    }

    if (!consent) {
      setErrors({ consent: true });
      return;
    }

    navigate('/payment', {
      state: {
        yogaRegistrationData: formData,
        productName,
        amount,
        quantity: 1,
      },
    });
  };

  return (
    <div className="form-page-wrapper">
      <Header />

      <form onSubmit={handleSubmit} className="satvic-form">
        <h2>{productName} Registration</h2>
        <p className="amount-display">Fee: ₹{amount}</p>

        {description && (
          <div className="batch-info-box">
            <p>{description}</p>
          </div>
        )}

        <div className="form-grid">
          <div className="full-width">
            <label>Full Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div>
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div>
            <label>Phone *</label>
            <PhoneInput
              country="in"
              value={formData.phone}
              onChange={phone =>
                setFormData(prev => ({ ...prev, phone }))
              }
            />
          </div>

          <div>
            <label>Date of Birth *</label>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleInputChange}
              max={new Date().toISOString().split('T')[0]}
              required
            />
          </div>

          <div>
            <label>Gender *</label>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleInputChange}
              required
            >
              <option value="">Select</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>

          <div className="full-width">
            <label>Select Time Slot *</label>
            <div className="selection-group">
              <label>
                <input
                  type="radio"
                  name="timeSlot"
                  value="Morning"
                  onChange={handleInputChange}
                />{' '}
                Morning
              </label>
              <label>
                <input
                  type="radio"
                  name="timeSlot"
                  value="Evening"
                  onChange={handleInputChange}
                />{' '}
                Evening
              </label>
            </div>
          </div>

          <div className="full-width">
            <label>Experience Level *</label>
            <div className="selection-group">
              <label>
                <input
                  type="radio"
                  name="experience"
                  value="Beginner"
                  onChange={handleInputChange}
                />{' '}
                Beginner
              </label>
              <label>
                <input
                  type="radio"
                  name="experience"
                  value="Intermediate"
                  onChange={handleInputChange}
                />{' '}
                Intermediate
              </label>
              <label>
                <input
                  type="radio"
                  name="experience"
                  value="Advanced"
                  onChange={handleInputChange}
                />{' '}
                Advanced
              </label>
            </div>
          </div>

          <div className="full-width">
            <label>Your Goals</label>
            <textarea
              name="goals"
              rows="3"
              value={formData.goals}
              onChange={handleInputChange}
              placeholder="What do you hope to achieve?"
            />
          </div>
        </div>

        {/* ✅ CONSENT (MANDATORY) */}
        <div className="full-width consent-box">
          <label className="consent-label">
            <input
              type="checkbox"
              checked={consent}
              onChange={e => {
                setConsent(e.target.checked);
                setErrors({});
              }}
            />
            <span>
              I agree to the{' '}
              <a
                href="http://localhost:3000/t&c"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms & Conditions
              </a>{' '}
              and{' '}
              <a
                href="http://localhost:3000/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </span>
          </label>

          {errors.consent && (
            <p className="error-message">
              You must agree before proceeding
            </p>
          )}
        </div>

        <button
          type="submit"
          className="submit-btn"
          disabled={!consent}
        >
          Proceed to Payment
        </button>
      </form>

      <HomeFooter />
    </div>
  );
};

export default YogaRegistrationForm;
